// utils
import avatarURL from "../../utils/avatarURL";

const EmployeeURL = (employeeId) => avatarURL(employeeId);

export default EmployeeURL;
